module.exports = __webpack_public_path__ + "img/Vivi.9b9c3c1.JPG";